/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../../../core";
import { Blueprint } from "./Blueprint";
import { Action } from "../../../../commons/types/Action";
import { SpaceAccess } from "../../../../spaces/types/SpaceAccess";
export const SpacePatternConfig = core.serialization.object({
    slug: core.serialization.string(),
    name: core.serialization.string(),
    blueprints: core.serialization.list(Blueprint),
    actions: core.serialization.list(Action).optional(),
    access: core.serialization.list(SpaceAccess).optional(),
    namespace: core.serialization.string().optional(),
    labels: core.serialization.list(core.serialization.string()).optional(),
    translationsPath: core.serialization.string().optional(),
});
